import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import AccordionButton from 'components/RwdCheckout/AccordionButton/AccordionButton';
import AccordionButtonEN from 'components/RwdCheckout/AccordionButton/locales/AccordionButton_en_US.js';
import AccordionButtonFR from 'components/RwdCheckout/AccordionButton/locales/AccordionButton_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(AccordionButtonEN, AccordionButtonFR);

const localization = createStructuredSelector({
    saveContinueButton: getTextFromResource(getText, 'saveContinueButton')
});

const fields = createStructuredSelector({
    localization
});

const withComponentProps = wrapHOC(connect(fields, null));

export default withComponentProps(AccordionButton);
